module.exports = "/_next/static/images/neostack-logo-b5925ff583b74b7b235b71d6bd509b55.png";